import request from "@/utils/request";
import { jsonHeaders } from "./api-header-conf.js";

export function queryRepayInfo(leaseId) {
  return request({
    jsonHeaders,
    url: `/plan/leaseId/${leaseId}`,
    method: "GET"
  });
}
export function querySelfRepay(wxid) {
  return request({
    jsonHeaders,
    url: `/plan/wx/${wxid}`,
    method: "GET"
  });
}
export function queryOtherRepay(sjhm, khmc, sfzhm) {
  return request({
    jsonHeaders,
    url: `/plan/phone/${sjhm}/${khmc}/${sfzhm}`,
    method: "GET"
  });
}

export function queryOverHistory(leaseId) {
  return request({
    jsonHeaders,
    url: `/plan/repay/${leaseId} `,
    method: "GET"
  });
}
